import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import VueTheMask from 'vue-the-mask'
import VueExcelXlsx from "vue-excel-xlsx"
import VModal from 'vue-js-modal'
import Vuex  from "vuex";
import httpCommon from "./http-common";
import setupInterceptors from './services/setupInterceptors';
import PortalVue from 'portal-vue';

Vue.config.productionTip = false
Vue.prototype.$http = httpCommon

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueTheMask)
Vue.use(VueExcelXlsx)
Vue.use(VModal)
Vue.use(Vuex)
Vue.use(PortalVue);

setupInterceptors(store);

new Vue({
    router,
    store,
    render: function (h) {
        return h(App)
    }
}).$mount('#app')
